const lineHeight = {
  name: "line-height",
  path: "/line-height",
  title: "line-height",
  description: "Utilities for controlling the line height of text.",
  value: {
    "line-height": {
      "leading-none": "1",
      "leading-tight": "1.25",
      "leading-snug": "1.375",
      "leading-normal": "1.5",
      "leading-relaxed": "1.625",
      "leading-loose": "2",
      "leading-<number>":"calc(var(--1) * <number>)",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="leading-none text-lg">The quick brown fox jumps over the lazy dog. (none)</p>
<p class="leading-tight text-lg">The quick brown fox jumps over the lazy dog. (tight)</p>
<p class="leading-snug text-lg">The quick brown fox jumps over the lazy dog. (snug)</p>
<p class="leading-normal text-lg">The quick brown fox jumps over the lazy dog. (normal)</p>
<p class="leading-relaxed text-lg">The quick brown fox jumps over the lazy dog. (relaxed)</p>
<p class="leading-loose text-lg">The quick brown fox jumps over the lazy dog. (loose)</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">leading-none</code> through <code class="text-color-gray-800 dark:text-color-white font-semibold">leading-loose</code> and <code class="text-color-gray-800 dark:text-color-white font-semibold">leading-<var>&lt;number&gt;</var></code> to control line height:
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">leading-none</small>
          <p class="leading-none text-sm text-color-gray-900 dark:text-color-gray-200">
            So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">leading-tight</small>
          <p class="leading-tight text-sm text-color-gray-900 dark:text-color-gray-200">
            So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">leading-snug</small>
          <p class="leading-snug text-sm text-color-gray-900 dark:text-color-gray-200">
            So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">leading-normal</small>
          <p class="leading-normal text-sm text-color-gray-900 dark:text-color-gray-200">
            So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">leading-relaxed</small>
          <p class="leading-relaxed text-sm text-color-gray-900 dark:text-color-gray-200">
            So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">leading-loose</small>
          <p class="leading-loose text-sm text-color-gray-900 dark:text-color-gray-200">
            So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">leading-8</small>
          <p class="leading-8 text-sm text-color-gray-900 dark:text-color-gray-200">
            So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.
          </p>
        </div>
      </div>
      `
    }
  ]
}
export default lineHeight;
<div className="leading-none leading-tight leading-snug leading-normal leading-relaxed leading-loose leading-8"></div>